import { render, staticRenderFns } from "./AdministrationProducts.vue?vue&type=template&id=15d0666f&scoped=true&"
import script from "./AdministrationProducts.vue?vue&type=script&lang=js&"
export * from "./AdministrationProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d0666f",
  null
  
)

export default component.exports